import { configureStore } from '@reduxjs/toolkit';
//import preConocimientoHecho from './slicers/preConocimientoHecho';
import { persistStore, persistReducer } from 'redux-persist';
import {tokenPersist} from './persists/persistKeys'


//import { composeWithDevTools } from 'redux-devtools-extension';
//import conocimientoHecho from './slicers/conocimientoHecho';
import tokenAuth from './slicers/tokenAuth';


// Agrego oscar.
//const persistPCDH = persistReducer(pcdhPersist, preConocimientoHecho)
const persistTknAuth = persistReducer(tokenPersist, tokenAuth)

const store = configureStore({
  reducer: {
    // Agrego oscar. 
    //pCDH: persistPCDH,
    tknAuth: persistTknAuth,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
  //  devTools: process.env.NODE_ENV !== 'production', // Solo en desarrollo
});

const persistor = persistStore(store);

export { store, persistor };
